module.exports = __webpack_public_path__ + "static/media/video.070fb8b0.mp4";